const TOC_DEFAULTS = {
  includedHeadings: [1, 2, 3],
  listStyle: "NUMBERED",
  indentation: "NESTED",
  fontSize: null,
  itemSpacing: 0,
  color: null
};
export {
  TOC_DEFAULTS
};
//# sourceMappingURL=defaults.js.map
